import request from "../utils/request";
import TimeUtils from "../utils/TimeUtils";

export const CHATBOT_API = {
    TRAINING: {
        list(filters) {
            return request.post(`/chatbot/unmatched/list`, { filters });
        },
        deleteById(id) {
            return request.delete(`/chatbot/unmatched/${id}`);
        },
        ignoreById(id) {
            return request.patch(`/chatbot/unmatched/${id}/ignore`);
        },
        train(id, storyId, storyVersion, blockId) {
            return request.post(`/chatbot/unmatched/${id}/train`, {
                storyId,
                storyVersion,
                blockId,
            });
        },
        multiDelete(ids) {
            return request.post(`/chatbot/unmatched/multi-delete`, { ids });
        },
        multiIgnore(ids) {
            return request.post(`/chatbot/unmatched/multi-ignore`, { ids });
        },
        multiTrain(ids, storyId, storyVersion, blockId) {
            return request.post(`/chatbot/unmatched/multi-train`, {
                ids,
                storyId,
                storyVersion,
                blockId,
            });
        },
    },
    USER_SEGMENTS: {
        listSegments() {
            return request.get(`/chatbot/user-segments/listSegments`, {});
        },
        createSegment({ name, users }) {
            return request.post(`/chatbot/user-segments/createSegment`, { name, users });
        },
        deleteUserFromSegment({ segmentId, userId }) {
            return request.delete(`/chatbot/user-segments/remove-user/${segmentId}/${userId}`);
        },
        removeSegment(id) {
            return request.delete(`/chatbot/user-segments/removeSegment/${id}`);
        },
        updateSegment({ id, name, users }) {
            return request.put(`/chatbot/user-segments/updateSegmentName/${id}`, { name, users });
        },
        addUserToSegment({ segmentId, userId }) {
            return request.post(`/chatbot/user-segments/addUserTOSegment`, { segmentId, userId });
        },
    },
    ARCHIVE: {
        list(filters = {}) {
            return request.get(`/chatbot/archive`, {
                params: {
                    ...filters,
                },
            });
        },
    },
    REPORT: {
        busiestPeriod(filters = {}) {
            return request.get(`/chatbot/report/busiest-period`, {
                params: {
                    ...filters,
                    tz: TimeUtils.getTimezone(),
                },
                timeout: 1000 * 60 * 2,
            });
        },
        timeSeries(filters = {}) {
            return request.get(`/chatbot/report/time-series`, {
                params: {
                    ...filters,
                    timeout: 1000 * 60 * 2,
                },
            });
        },
        overall(filters = {}) {
            return request.get(`/chatbot/report/overall`, {
                params: {
                    ...filters,
                    tz: TimeUtils.getTimezone(),
                },
                timeout: 1000 * 60 * 2,
            });
        },
        ratingDistribution(filters = {}) {
            return request.get(`/chatbot/report/rating-distribution`, {
                params: {
                    ...filters,
                    tz: TimeUtils.getTimezone(),
                },
                timeout: 1000 * 60 * 2,
            });
        },
        blockPopularity(filters = {}) {
            return request.get(`/chatbot/report/block-popularity`, {
                params: {
                    ...filters,
                    tz: TimeUtils.getTimezone(),
                },
                timeout: 1000 * 60 * 5,
            });
        },
    },
    KNOWLEDGE_BASE: {
        listKnowledgeBaseLite: (id, page, pageSize) => {
            return request.get(`/chatbot/story/${id}/ai/knowledge-base-lite`, {
                params: {
                    page: page,
                    pageSize: pageSize,
                },
                timeout: 1000 * 60 * 5,
            });
        },
        listKnowledgeBase: (id, type, page, pageSize) => {
            let url = `/chatbot/story/${id}/ai/knowledge-base`;
            let params = `?page=${page}&pageSize=${pageSize}`;
            if (type) {
                params = params + `&type=${type}`;
            }
            url = url + params;
            return request.get(url, {
                timeout: 1000 * 60 * 5,
            });
        },
        getKnowledgeBaseById: (storyId, id) => {
            return request.get(`/chatbot/story/${storyId}/ai/knowledge-base/${id}`, {
                timeout: 1000 * 10,
            });
        },
        changeStateMultiKnowledgeBase: (storyId, ids, enabled) => {
            return request.post(
                `/chatbot/story/${storyId}/ai/knowledge-base/multi-state-change`,
                { ids, enabled },
                {
                    timeout: 1000 * 10,
                }
            );
        },
        deleteMultiKnowledgeBase: (storyId, ids) => {
            return request.post(
                `/chatbot/story/${storyId}/ai/knowledge-base/multi-delete`,
                { ids },
                {
                    timeout: 1000 * 10,
                }
            );
        },
        createKnowledgeBase: (storyId, type, webpage, assetId, faq, article, aiFunction) => {
            return request.post(
                `/chatbot/story/${storyId}/ai/knowledge-base`,
                { type, webpage, assetId, faq, article, aiFunction },
                {
                    timeout: 1000 * 10,
                }
            );
        },
        knowledgeBaseUpdate: (storyId, id, payload) => {
            return request.post(`/chatbot/story/${storyId}/ai/knowledge-base/${id}`, payload, {
                timeout: 1000 * 10,
            });
        },
        knowledgeBaseCountByType: (storyId) => {
            return request.get(`/chatbot/story/knowledgeBaseCountByType/${storyId}`, {
                timeout: 1000 * 10,
            });
        },
    },

    listStories() {
        return request.get(`/chatbot/list-stories`);
    },

    getStory({ id, version }) {
        return request.get(`/chatbot/story/${id}/v/${version}`);
    },
    updateStoryName({ id, title }) {
        return request.put(`/chatbot/story/${id}`, { title });
    },
    updateStorySingleKey({ id, key, value }) {
        return request.post(`/chatbot/story/${id}/single-key`, { key, value });
    },
    getStoryDraftDetail({ id }) {
        return request.get(`/chatbot/story/${id}/v/draft`);
    },

    deleteSingleBlock({ id, version, blockId }) {
        return request.delete(`/chatbot/story/${id}/v/${version}/single/${blockId}`);
    },
    insertMultipleBlocks({ id, version, targetBlockId, block }) {
        return request.post(`/chatbot/story/${id}/v/${version}/b/${targetBlockId}/insert-multiple-blocks`, { block });
    },

    deleteWithChildren({ id, version, blockId }) {
        return request.delete(`/chatbot/story/${id}/v/${version}/recursive/${blockId}`);
    },

    updateBlock({ id, version, blockId, payload }) {
        return request.post(`/chatbot/story/${id}/v/${version}/b/${blockId}`, { payload });
    },

    addBlock({ id, version, blockId, type }) {
        return request.put(`/chatbot/story/${id}/v/${version}/b/${blockId}`, { type });
    },

    moveBlock({ id, version, sourceBlockId, targetBlockId }) {
        return request.post(`/chatbot/story/${id}/v/${version}/b/${sourceBlockId}/move`, { targetBlockId });
    },
    copyBlock({ id, version, sourceBlockId, targetBlockId }) {
        return request.post(`/chatbot/story/${id}/v/${version}/b/${sourceBlockId}/copy`, { targetBlockId });
    },

    updateBoardSingleKey({ id, version, key, value }) {
        return request.post(`/chatbot/story/${id}/v/${version}`, { key, value });
    },

    addCustomAttribute({ id, version, attribute }) {
        return request.put(`/chatbot/story/${id}/v/${version}/custom-attribute`, { attribute });
    },

    deleteAllStories() {
        return request.delete(`/chatbot/story/all`);
    },

    deleteStory(id) {
        return request.delete(`/chatbot/story/${id}`);
    },

    duplicateStory(id) {
        return request.post(`/chatbot/story/${id}/duplicate`);
    },

    makeDefaultStory(payload) {
        const id = payload.selectedStory;
        const integrationApp = payload.integrationApp;
        return request.post(`/chatbot/story/${id}/make-default`, { integrationApp });
    },

    revokeDefaultStory(payload) {
        const integrationApp = payload.integrationApp;
        return request.post(`/chatbot/story/revoke-default`, { integrationApp });
    },

    createEmptyStory({ title, description }) {
        return request.put(`/chatbot/story`, { title, description });
    },
    createStoryFromTemplate(slug) {
        return request.put(`/chatbot/story/import/${slug}`, {});
    },
    createStoryFromDiagram(board) {
        return request.put(`/chatbot/story/import/diagram`, { board });
    },

    publishBoard({ id, version, publishVersion }) {
        return request.patch(`/chatbot/story/${id}/v/${version}/${publishVersion}`);
    },
    updateVersionName({ storyId, boardId, versionName }) {
        return request.put(`/chatbot/story/${storyId}/update-version-name`, { boardId, versionName });
    },
    restore({ storyId, versionId }) {
        return request.put(`/chatbot/story/${storyId}/restore`, { versionId });
    },
    getAllChatBotTicketTags() {
        return request.get("/chatbot/ticket/tags");
    },
    getEntities() {
        return request.get("/chatbot/entity");
    },
    conditionalGetEntities({ id }) {
        return request.get(`/chatbot/entity/${id}`);
    },

    addEntities({ name, entries }) {
        return request.post("/chatbot/entity/new", { name: name, entries: entries });
    },
    updateEntity({ id, name, entries }) {
        return request.put(`/chatbot/entity/id/${id}/update-entity`, { name: name, entries: entries });
    },
    deleteEntity({ id }) {
        return request.delete(`chatbot/entity/id/${id}/delete-entity`);
    },
    undoDiagram(id, version) {
        return request.get(`/chatbot/story/${id}/v/${version}/undo`);
    },
    redoDiagram(id, version) {
        return request.get(`/chatbot/story/${id}/v/${version}/redo`);
    },
    getAllWebHooks() {
        return request.get("/chatbot/webhooks");
    },
    addWebHook({ name, url, verificationToken, basicAuthentication, headers }) {
        return request.post("chatbot/webhooks/new", { name, url, verificationToken, basicAuthentication, headers });
    },
    updateWebHook(id, payload) {
        return request.put(`/chatbot/webhooks/id/${id}/update`, { query: payload });
    },
    deleteWebHook(id) {
        return request.delete(`/chatbot/webhooks/id/${id}/delete`);
    },
    updateSettings(storyId, settings) {
        return request.put(`/chatbot/${storyId}/settings`, {
            settings,
        });
    },
  
};
